<template>
    <div class="landing-page">
        <!--导航-->
        <section id="landing">
            <nav class="navbar navbar-default navbar-fixed-top" >
                <div class="container">
                    <!--小屏幕导航按钮和logo-->
                    <div class="navbar-header">
                        <button class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                        </button>
                        <div class="logo-container">
                            <a>
                                <img class="logo-image" src="../../static/image/landing/company.png">
                            </a>
                            <div class="desc-container">
                                <div class="desc">
                                    <span style="letter-spacing: 2.7px;margin-right: 40px;">广州市医保定点医疗机构</span>
                                    <span style="letter-spacing:2.8px">广州市驾驶人体检定点单位</span>
                                </div>
                                <div class="desc">
                                    <span style="margin-right:40px;">广东省职业健康协会成员单位</span>
                                    <span style="">广东省食品从业人员健康证办理定点单位</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--小屏幕导航按钮和logo-->
                    <!--导航-->
                    <div class="navbar-collapse collapse">
                        <ul class="nav navbar-nav navbar-right">
                            <li><a href="#landing" data-toggle="collapse" data-target=".navbar-collapse">首页</a></li>
                            <li><a href="#company" data-toggle="collapse" data-target=".navbar-collapse">公司概况</a></li>
                            <li><a href="http://www.ytcheck.top/app/#/login">官方商城</a></li>
                            <li><a href="#doctor" data-toggle="collapse" data-target=".navbar-collapse">专家介绍</a></li>
                            <li><a href="https://ytcheck.6ewei.com/yy/views/inquiry.html?v=1#/">互联网诊疗</a></li>
                            <li><a href="#contact" data-toggle="collapse" data-target=".navbar-collapse">联系我们</a></li>
                        </ul>
                    </div>
                    <!--导航-->
                </div>
                <div class="nav-tab-container">
                    <div class="tab-container">
                        <div class="tab"><a href="#landing">首页</a></div>
                        <div class="tab"><a href="#company">公司概况</a></div>
                        <div class="tab"><a href="http://www.ytcheck.top/app/#/login">官方商城</a></div>
                        <div class="tab"><a href="#doctor">专家介绍</a></div>
                        <div class="tab"><a href="https://ytcheck.6ewei.com/yy/views/inquiry.html?v=1#/">互联网诊疗</a></div>
                        <div class="tab"><a href="#contact-banner">联系我们</a></div>
                    </div>
                </div>
            </nav>
        </section>
        
        <!--导航-->
        <section id="banner" class="banner">
            <!-- <img style="width: 100%" src="../../static/image/landing/banner.png"> -->
            <img style="margin: auto;display: block;max-width: 2000px;width: 100%" src="../../static/image/landing/banner.png">
            <div v-if="showQrWindow" id="qr-window">
                <div class="title">
                    <span>关注微信</span>
                    <span class="close" @click="showQrWindow = false">×</span>
                </div>
                <div>
                    <img style="width: 100%;" src="../../static/image/landing/qrcode.jpeg">
                </div>
                <div style="padding-bottom: 10px;">扫码关注查询报告</div>
            </div>
        </section>

        <!--home-->
        <div id="home">
            <div class="container">
                <h2 class="title">公司介绍</h2>
                <section class="row" id="company">
                    <div class="col-md-5">
                        <img src="static/image/landing/company-introduce.png" class="img-responsive" style="margin-top: 0;" />
                    </div>
                    <div class="col-md-7" style="font-size:16px;">
                        <p style="text-align: left;">
                            广州亚太国际健康体检有限公司成立于2016年。公司地处美丽的黄埔区科学城内，占地面积达4000余平方米。
                        </p>
                        <p style="text-align: left;">
                            作为广州首家生态式体检中心，广州亚太国际健康体检中心拥有国际化的体检设备，信息化的体检管理系统和专业化的医疗体检团队，承接个人、团体及企事业单位的健康体检、职业健康检查和健康管理，致力于成为国际化的健康体检中心。
                        </p>
                        <p style="text-align: left;">
                            中心开设VIP区、普检区，综合门诊部、为每位客户提供舒适专业的医疗健检需求。
                        </p>
                        <p style="text-align: left;">
                            秉承科技守护健康的宗旨，亚太国际健康体检中心运用高水准的医技团队，规范化的操作标准，改善国人医疗健康体检服务质量，推动中国医疗服务管理模式的变革。
                        </p>
                    </div>
                </section>
                <section id="doctor">
                    <div style="margin-top: 54px;margin-bottom: 20px;">
                        <h5 style="text-align: left;color: #fff;font-size: 20px;padding-bottom: 0;">
                            <span style="display:inline-block;border-bottom: 3px solid #fff;padding-bottom: 9px;">专家介绍</span>
                        </h5>
                    </div>
                    <div class="swiper-container" style="overflow: hidden;" v-if="!isSmallPage">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide doctor-container">
                                <div class="doctor" v-for="(item, index) in doctors" v-if="index < 5">
                                    <img class="image" :src="item.image">
                                </div>
                            </div>
                            <div class="swiper-slide doctor-container">
                                <div class="doctor" v-for="(item, index) in doctors" v-if="index >= 5 && index < 10">
                                    <img class="image" :src="item.image">
                                </div>
                            </div>
                            <div class="swiper-slide doctor-container">
                                <div class="doctor" v-for="(item, index) in doctors" v-if="index >= 10">
                                    <img class="image" :src="item.image">
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="swiper-container" style="overflow: hidden;" v-if="isSmallPage"> 
                        <div class="swiper-wrapper">
                            <div class="swiper-slide doctor-container">
                                <div class="doctor" v-for="(item, index) in doctors" v-if="index < 3">
                                    <img class="image" :src="item.image">
                                </div>
                            </div>
                            <div class="swiper-slide doctor-container">
                                <div class="doctor" v-for="(item, index) in doctors" v-if="index >= 3 && index < 6">
                                    <img class="image" :src="item.image">
                                </div>
                            </div>
                            <div class="swiper-slide doctor-container">
                                <div class="doctor" v-for="(item, index) in doctors" v-if="index >= 6 && index < 9">
                                    <img class="image" :src="item.image">
                                </div>
                            </div>
                            <div class="swiper-slide doctor-container">
                                <div class="doctor" v-for="(item, index) in doctors" v-if="index >= 9 && index < 12">
                                    <img class="image" :src="item.image">
                                </div>
                            </div>
                            <div class="swiper-slide doctor-container">
                                <div class="doctor" v-for="(item, index) in doctors" v-if="index >= 12">
                                    <img class="image" :src="item.image">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-pagination" id='swiper-pagination'></div>
                </section>
            </div>
        </div>
        <!--home-->
        <section id="more-info" class="more-info">
            <div class="container">
                <div class="tab-container">
                    <div class="tab" :class="{active: moreInfoActiveIndex == 0}" @click="moreInfoActiveIndex = 0">医院环境</div>
                    <div class="tab" :class="{active: moreInfoActiveIndex == 1}" @click="moreInfoActiveIndex = 1">资质荣誉</div>
                    <div class="tab" :class="{active: moreInfoActiveIndex == 2}" @click="moreInfoActiveIndex = 2">医疗设备</div>
                </div>
                <div class="inv-container" v-if="moreInfoActiveIndex == 0">
                    <div class="inv">
                        <img class="image" src="../../static/image/landing/inv-1.png">
                    </div>
                    <div class="inv">
                        <img class="image" src="../../static/image/landing/inv-2.png">
                    </div>
                    <div class="inv">
                        <img class="image" src="../../static/image/landing/inv-3.png">
                    </div>
                    <div class="inv">
                        <img class="image" src="../../static/image/landing/inv-4.png">
                    </div>
                    <div class="inv">
                        <img class="image" src="../../static/image/landing/inv-5.png">
                    </div>
                </div>
                <div class="inv-container" v-show="moreInfoActiveIndex == 1">
                    <div class="inv-swiper-container" style="overflow: hidden;">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <img class="image" style="width: 100%;" src="../../static/image/landing/honor-1.png">
                            </div>
                            <div class="swiper-slide">
                                <img class="image" style="width: 100%;" src="../../static/image/landing/honor-2.png">
                            </div>
                            <div class="swiper-slide">
                                <img class="image" style="width: 100%;" src="../../static/image/landing/honor-3.png">
                            </div>
                            <div class="swiper-slide">
                                <img class="image" style="width: 100%;" src="../../static/image/landing/honor-4.png">
                            </div>
                            <div class="swiper-slide">
                                <img class="image" style="width: 100%;" src="../../static/image/landing/honor-5.png">
                            </div>
                            <div class="swiper-slide">
                                <img class="image" style="width: 100%;" src="../../static/image/landing/honor-6.png">
                            </div>
                            <div class="swiper-slide">
                                <img class="image" style="width: 100%;" src="../../static/image/landing/honor-7.png">
                            </div>
                            <div class="swiper-slide">
                                <img class="image" style="width: 100%;" src="../../static/image/landing/honor-8.png">
                            </div>
                            <div class="swiper-slide">
                                <img class="image" style="width: 100%;" src="../../static/image/landing/honor-9.png">
                            </div>
                            <div class="swiper-slide">
                                <img class="image" style="width: 100%;" src="../../static/image/landing/honor-10.png">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="inv-container" v-if="moreInfoActiveIndex == 2">
                    <div class="inv">
                        <img class="image" src="../../static/image/landing/device-1.png">
                    </div>
                    <div class="inv">
                        <img class="image" src="../../static/image/landing/device-2.png">
                    </div>
                    <div class="inv">
                        <img class="image" src="../../static/image/landing/device-3.png">
                    </div>
                    <div class="inv">
                        <img class="image" src="../../static/image/landing/device-4.png">
                    </div>
                    <div class="inv">
                        <img class="image" src="../../static/image/landing/device-5.png">
                    </div>
                </div>
            </div>
        </section>
        

        <!--contact-->
        <section id="contact" class="contact">
            <div class="lvjing">
                <div class="container">
                    <div class="col-md-6" style="color:#000;margin-bottom: 20px;">
                        <div style="font-size: 23px;margin-bottom: 40px;">广州亚太国际健康体检有限公司</div>
                        <div style="font-size: 14px;margin-bottom: 10px;">地址: 广州科学城开泰大道603号大壮国际广场G1栋三层</div>
                        <div style="font-size: 14px;margin-bottom: 10px;">邮箱: gzytmail@126.com</div>
                        <div style="font-size: 14px;margin-bottom: 10px;">网址: www.yataitijian.com</div>
                        <div style="font-size: 14px;margin-bottom: 10px;">电话: 400-8939-822</div>
                        <div style="font-size: 14px;margin-bottom: 10px;">门诊: 18825057396</div>
                        <div style="font-size: 14px;margin-bottom: 10px;">投诉建议：18825056096</div>
                        <div style="font-size: 10px;margin-bottom: 10px;">Copyright&nbsp;©&nbsp;2013-2023&nbsp;&nbsp;<a style="color: #000000;" target="_blank" href="https://beian.miit.gov.cn/">粤ICP备17129177号</a></div>
                        <div style="display:flex;align-items: center;margin-top: 40px;">
                            <img src="../../static/image/landing/qrcode.jpeg" style="width:150px;">
                            <div style="margin-left:20px;color: ;">微信扫码预约</div>
                        </div>
                    </div>
                    <!-- <div class="col-md-6">
                        <img src="../../static/image/landing/contact.jpg" style="width:100%;">
                    </div> -->
                    <!-- <div class="row" style="margin-top: 20px;">
                        <div class="col-md-12">
                            <p style="color:#000;">
                                Copyright&nbsp;©&nbsp;2013-2023&nbsp;&nbsp;广州亚太国际健康体检有限公司&nbsp;&nbsp;粤ICP备17129177号
                            </p>
                        </div>
                    </div> -->
                </div>
            </div>
        </section>
        <!--contact-->

        <section id="contact-banner" class="contact-banner">
            <img src="../../static/image/landing/footer.png" style="width:100%;">
            <div class="content">
                Copyright ©2021 广州亚太国际健康体检有限公司 <a target="_blank" href="https://beian.miit.gov.cn/">粤ICP备17129177号</a>
            </div>
        </section>

        <!--footer-->
        <!-- <footer>
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <p>
                            Copyright&nbsp;©&nbsp;2013-2023&nbsp;&nbsp;广州亚太国际健康体检有限公司&nbsp;&nbsp;粤ICP备17129177号
                        </p>
                    </div>
                </div>
            </div>
        </footer> -->
        <!--footer-->
    </div>
</template>

<script>
    import Swiper, { Navigation, Pagination, Autoplay } from "swiper";
    Swiper.use([Autoplay, Navigation, Pagination]);
    export default {
        data () {
            return {
                showQrWindow: true,
                interval: null,
                swiper: null,
                isSmallPage: true,
                doctors: [{
                    image: '../../static/image/landing/doctor-1.png',
                }, {
                    image: '../../static/image/landing/doctor-2.png',
                }, {
                    image: '../../static/image/landing/doctor-3.png',
                }, {
                    image: '../../static/image/landing/doctor-4.png',
                }, {
                    image: '../../static/image/landing/doctor-5.png',
                }, {
                    image: '../../static/image/landing/doctor-6.png',
                }, {
                    image: '../../static/image/landing/doctor-7.png',
                }, {
                    image: '../../static/image/landing/doctor-8.png',
                }, {
                    image: '../../static/image/landing/doctor-9.png',
                }, {
                    image: '../../static/image/landing/doctor-10.png',
                }, {
                    image: '../../static/image/landing/doctor-11.png',
                }, {
                    image: '../../static/image/landing/doctor-12.png',
                }, {
                    image: '../../static/image/landing/doctor-13.png',
                }, {
                    image: '../../static/image/landing/doctor-14.png',
                }, {
                    image: '../../static/image/landing/doctor-15.png',
                }],
                moreInfoActiveIndex: 0
            }
        },
        mounted(){
            if (document.documentElement.clientWidth > 992) {
                this.isSmallPage = false
                setTimeout(()=> {
                    const swiper = new Swiper('.inv-swiper-container', {
                        speed: 1000, //匀速时间
                        autoplay: {
                            disableOnInteraction: false,
                            delay: 3000
                        },
                        spaceBetween: 20,
                        slidesPerView: 5,
                    })
                }, 200)
            } else {
                this.isSmallPage = true
                setTimeout(()=> {
                    const swiper = new Swiper('.inv-swiper-container', {
                        speed: 1000, //匀速时间
                        autoplay: {
                            disableOnInteraction: false,
                            delay: 3000
                        },
                        spaceBetween: 20,
                        slidesPerView: 3
                    })
                }, 200)
            }
            this.swiper = new Swiper('.swiper-container', {
                speed: 10000, //匀速时间
                autoplay: {
                    disableOnInteraction: false
                },
                loop: true,
                spaceBetween: 20,
                pagination: {
                    el: '.swiper-pagination'
                }
            })
            const items = document.getElementsByClassName('swiper-pagination-bullet')
            for (let i = 0; i < items.length; i++) {
                items[i].onclick = ($event)=>{
                    this.swiper.slideTo(i)
               } 
            }
            
            
            // items.forEach((element,index) => {
            //     console.log(index)
            // })
            // document.getElementById('swiper-pagination').on("click","span",function(){
            //     var index = $(this).index();
            //     this.swiper.slideTo(index);
            // })
            // this.moveWindow()
        },
        methods:{
            moveWindow(){
                let img = document.getElementById('qr-window')
                if (!img) return
                let x = 0, y = 0                                    // 元素离页面水平、垂直方向距离 
                let xflag = true, yflag = true                      // 设置水平、垂直标志位
                this.interval = setInterval(() => {
                    if (!this.showQrWindow) {
                        clearInterval(this.interval)
                    }
                    // 获取页面宽高
                    let w = document.body.offsetWidth
                    let h = document.body.offsetHeight

                    // 判断图片碰壁的四种情况
                    if (x == 0) xflag = true                        // 碰到左边
                    if (y == 0) yflag = true                        // 碰到上边
                    if (x == w - img.offsetWidth) xflag = false     // 碰到右边
                    if (y == h - img.offsetHeight) yflag = false    // 碰到下边

                    // 根据碰壁情况进行改变x和y的值
                    // 方法一
                    // if (xflag && yflag) x++, y++                    // 浮动方向：右下
                    // if (xflag && !yflag) x++, y--                   // 浮动方向：右上
                    // if (!xflag && yflag) x--, y++                   // 浮动方向：左下
                    // if (!xflag && !yflag) x--, y--                  // 浮动方向：左上
                    
                    // 方法二
                    xflag ? x++ : x--
                    yflag ? y++ : y--

                    // 设置图片的位置
                    img.style.left = x + 'px'
                    img.style.top = y + 'px'
                }, 50)
            }
        }
    }
</script>
<style scoped lang="scss">
    #qr-window{
        display: none;
    }
    .navbar-default{
        height: 70px;
    }
    .desc-container{
        display: none;
    }
    #home{
        padding-bottom: 20px;
        .title{
            text-align: left;
            color: #fff;
            font-size: 30px;
            padding-bottom: 9px;
        }
    }
    .nav-tab-container{
        display: none;
    }
    .banner {
        padding-top: 70px;
        position: relative;
    }
    .doctor-container{
        display: flex;
        justify-content: space-between;
        gap: 20px;
        .doctor{
            flex: 1;
            .image{
                width: 100%;
            }
        }
    }
    .swiper-wrapper.big{
        display: none;
    }
    .swiper-wrapper.small{
        display: flex;
    }
    /deep/ .swiper-pagination{
        margin-top: 24px;
        .swiper-pagination-bullet{
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #1CFEF0;
            margin-left: 10px;
            cursor: pointer;
        }
        .swiper-pagination-bullet-active{
            width: 38px;
            background-color: #25EADE;
            border-radius: 40px;
        }
    }
    .contact{
        display: block;
    }
    .contact-banner{
        display: none;
    }
    .more-info{
        padding-top: 54px;
        .tab-container{
            display: flex;
            justify-content: flex-start;
            gap: 20px;
            margin-bottom: 33px;
            border-bottom: 1px solid #D9D9D9;
            .tab{
                color: #1E1E1E;
                font-size: 20px;
                position: relative;
                cursor: pointer;
                padding-bottom: 11px;
                &::after{
                    content: ' ';
                    position: absolute;
                    top: 5px;
                    right: -12px;
                    width: 1px;
                    height: 19px;
                    background-color: #D9D9D9;
                }
                &.active{
                    border-bottom: 5px solid #11C0B6;
                }
            }
            .tab:last-child{
                &::after{
                    display: none;
                }
            }
        }
        .inv-container{
            display: flex;
            flex-flow: column;
            gap: 20px;
            .inv{
                flex: 1;
                .image{
                    width: 100%;
                }
            }
        }
    }
    .product-container{
        background-color: #fff;
        border-radius: 10px;
        padding-top: 60px;
        overflow: hidden;
        cursor: pointer;
        margin-bottom: 10px;
    }
    .product-container .image{
        height: 250px;
    }
    .product-container .text{
        padding: 20px 0;
    }
    .product-container:hover .text{
        color: #FFFFFF;
        background: linear-gradient(to right, rgba(91, 214, 200, 0.7), rgba(27, 150, 199, 0.7));
    }
    /*之前是ease-out*/
    /*::v-deep .swiper-container-free-mode>.swiper-wrapper {
        -webkit-transition-timing-function: linear; 
        -moz-transition-timing-function: linear;
        -ms-transition-timing-function: linear;
        -o-transition-timing-function: linear;
        transition-timing-function: linear;
        margin: 0 auto;
    }*/
    .devive{
        text-align: center;
    }
    .device .image{
        padding: 0 10px;
        text-align: center;
    }
    .device .image img{
        height: 65px;
    }
    .device .name{
        font-size: 12px;
        margin: 20px 0 10px;
        color: #fff;
        text-align: center;
    }
    .device .name .label{
        display: none;
    }
    .device .sub-name{
        font-size: 10px;
        color: #fff;
        text-align: center;
    }
    .logo-image{
        width: 200px;
        margin-top: 18px;
        margin-left: 9px;
    }
    @media (min-width: 992px) {
        .navbar-fixed-top{
            position: unset;
        }
        #qr-window{
            display: block;
            width: 155px;
            text-align: center;
            background-color: #fff;
            font-weight: bold;
            position: fixed;
            bottom: 100px;
            right: 0;
            z-index: 2000;
            .title{
                height: 38px;
                line-height: 38px;
                background-color: #F5F0F0;
                position: relative;
                .close{
                    display: inline-block;
                    background-color: rgba(0, 0, 0, 0.65);
                    width: 14px;
                    height: 14px;
                    line-height: 10px;
                    font-size: 10px;
                    border-radius: 50%;
                    color: #fff;
                    position: absolute;
                    top: 10px;
                    right: 10px;
                }
            }
        }
        .logo-container{
            display: flex;
            justify-content: flex-start;
            padding-top: 43px;
            .logo-image{
                width: 400px;
                margin: 0;
            }
            .desc-container{
                display: block;
                height: 60px;
                border-radius: 30px;
                background-color: #ffffff;
                padding: 5px 25px;
                margin-left: 20px;
                .desc{
                    font-size: 14px;
                    line-height: 25px;
                    color: #209E8D;
                }
            }
        }
        .navbar-default{
            height: 223px;
        }
        .navbar-collapse {
            display: none !important;
        }
        .nav-tab-container{
            display: block;
            width: 100%;
            background-color: rgba(255, 255, 255, 0.25);
            height: 37px;
            margin-top: 28px;
            .tab-container{
                display: flex;
                justify-content: space-between;
                min-width: 992px;
                max-width: 1336px;
                margin: 0 auto;
                padding: 0 15px;
                .tab{
                    color: #ffffff;
                    font-size: 24px;
                    position: relative;
                    cursor: pointer;
                    &::after{
                        content: ' ';
                        position: absolute;
                        top: 7px;
                        right: -80px;
                        width: 1px;
                        height: 22px;
                        background-color: #ffffff;
                    }
                }
                .tab:last-child{
                    &::after{
                        display: none;
                    }
                }
            }
        }
        .banner {
            padding-top: 0;
            padding: 0 50px 0;
            background-image: url('../../static/image/landing/nav-image.png');
            background-size: 100% 100%;
/*            min-width: 1440px;*/
        }
        #home{
            .title{
                font-size: 64px;
            }
        }
        .doctor-container{
            .doctor{
                width: 20%;
            }
        }
        .swiper-wrapper.big{
            display: flex;
        }
        .swiper-wrapper.small{
            display: none;
        }
        /deep/ .swiper-pagination{
            margin-top: 24px;
            .swiper-pagination-bullet{
                display: inline-block;
                width: 20px;
                height: 20px;
                border-radius: 50%;
                background-color: #1CFEF0;
                margin-left: 15px;
                cursor: pointer;
            }
            .swiper-pagination-bullet-active{
                width: 68px;
                background-color: #25EADE;
                border-radius: 40px;
            }
        }
        .more-info{
            padding-bottom: 63px;
            .tab-container{
                .tab{
                }
            }
            .inv-container{
                flex-flow: row;
                .inv{
                    .image{
                        width: 100%;
                    }
                }
            }
        }
        .contact{
            display: none;
        }
        .contact-banner{
            display: block;
            position: relative;
            .content{
                color: #ffffff;
                position: absolute;
                bottom: 20px;
                left: 50%;
                transform: translateX(-50%);
            }
        }
        .product-container{
            margin-bottom: 0;
        }
        .product-container .text{
            padding: 30px 0;
        }
        .product-container .image{
            height: 200px;
        }
        .device .image img{
            height: 200px;
        }
        .device .name{
            font-size: 16px;
            margin: 20px 0 10px;
            color: #fff;
            text-align: center;
        }
        .device .name .label{
            display: inline-block;
        }
        .device .sub-name{
            color: #fff;
            text-align: center;
        }
    }
    @media (min-width: 1400px){
        .container{
            width: 1300px;
        }
    }
    @media (min-width: 1600px){
        .container{
            width: 1500px;
        }
    }
    @media (min-width: 1800px){
        .container{
            width: 1600px;
        }
    }
    @media (min-width: 2000px){
        .container{
            width: 1800px;
        }
    }
    @media (min-width: 2200px){
        .container{
            width: 2000px;
        }
    }
    @media (min-width: 2500px){
        .container{
            width: 2000px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/landing.vue